import { AppBar, DialogActions, DialogContent, TextField, Toolbar, Typography } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import { GetDataAtual } from "app/Core/Helpers";
import _ from "lodash";
import MobileDetect from "mobile-detect";
import React, { useEffect, useState } from "react";

const md = new MobileDetect(window.navigator.userAgent);

const EvolucaoExameEdit = (props) => {

  const { onClose, open, editElement } = props;
  const [form, setForm] = useState(null);

  useEffect(() => {
    if (!_.isNull(open) && _.isNull(form)) {
      setForm({ ...open, "name": open.tipo === "linha" ? GetDataAtual(null, "usa") : (open.name ?? "") });
    }
    if (_.isNull(open) && !_.isNull(form)) {
      setForm(null);
    }
  }, [open]);

  function canBeSubmitted() {
    return true;
  }

  function onChange(ev) {
    setForm(_.set({ ...form }, ev.target.name, ev.target.value));
  }

  return (
    <React.Fragment>
      <XAPPDialog
        id="EvolucaoExameEdit"
        open={!_.isNull(form)}
        onClose={() => onClose()}
        fullWidth
        maxWidth={md.mobile() !== null ? "lg" : "sm"}
      >
        <AppBar position="static" elevation={1}>
          <Toolbar className="flex w-full min-h-0">
            <Typography variant="subtitle1 text-white">
              {`Editar ${form?.tipo}`}
            </Typography>
            <div className="flex-1" />
            <XAPPButton
              type="icon"
              icon={"close"}
              iconProps={"text-20 text-white"}
              className="p-6"
              onClick={() => onClose()}
            />
          </Toolbar>
        </AppBar>
        <DialogContent classes={{ root: "p-24" }}>
          {form?.tipo === "linha" &&
            <div className="flex sm:flex-no-wrap flex-wrap gap-8 mb-8">
              <TextField
                className="w-full"
                label={"Data"}
                key={"name"}
                name={"name"}
                value={form.name}
                onChange={onChange}
                required={true}
                variant="outlined"
                fullWidth
                autoFocus
                type="date"
                InputLabelProps={{ shrink: true }}
              />
            </div>
          }
          {form?.tipo === "coluna" &&
            <div className="flex sm:flex-no-wrap flex-wrap gap-8 mb-8">
              <TextField
                className="w-full"
                label={"Nome"}
                key={"name"}
                name={"name"}
                value={form.name}
                onChange={onChange}
                required={true}
                variant="outlined"
                fullWidth
                autoFocus
                InputLabelProps={{ shrink: true }}
              />
            </div>
          }
          {form?.tipo === "data" &&
            <div className="flex sm:flex-no-wrap flex-wrap gap-8 mb-8">
              <TextField
                className="w-full"
                label={"Detalhe"}
                key={"detalhe"}
                name={"detalhe"}
                value={form.detalhe}
                onChange={onChange}
                required={true}
                variant="outlined"
                fullWidth
                autoFocus
                InputLabelProps={{ shrink: true }}
              />
            </div>
          }
        </DialogContent>
        <AppBar position="static" elevation={3} color="textSecondary">
          <Toolbar className="flex w-full justify-end min-h-0">
            <DialogActions>
              <XAPPButton
                type="Button"
                className="bg-green hover:bg-green text-white mr-8"
                variant="contained"
                color="primary"
                onClick={() => editElement(form?.tipo, { ...form, "tipo": undefined })}
                disabled={!canBeSubmitted()}
                iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                icon={"save"}
                label={md.mobile() === null && md.tablet() === null ? "Salvar" : ""}
              />
            </DialogActions>
          </Toolbar>
        </AppBar>
      </XAPPDialog>
    </React.Fragment>
  );
};

export default EvolucaoExameEdit;
